import React, {useState, useEffect} from 'react'
import Loading from '../../../../common/Loading'
import {useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import clinicService from '../../../../../services/clinic.service'
import LinksCard from './LinksCard'
import AddLinksForm from './AddLinksForm'

function Links() {
    const [loading, setLoading] = useState(false)
    const {clinicId} = useParams()
    const [linkArray, setLinkArray] = useState([])
    const [addNew, setAddNew] = useState(false)

    useEffect(() => {
        getLinks()
    }, [])

    const handleAddClick = () => {
        setAddNew(!addNew)
    }

    const getLinks = () => {
        setLoading(true)
        clinicService.getReputationLinks(clinicId)
            .then((res) => {
                setLinkArray(res.data)
                setLoading(false)
            })
            .catch((err) => {
                console.log(err)
                setLoading(false)
            })
    }

    return (
        <div className="card card-padding card-border shadow-none">
            <div className="border-0">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <div className="card-title mb-0 text-primary">
                            <i className="bi bi-link-45deg me-2"></i>
                            Reputation Links
                        </div>
                    </div>
                    <button
                        className={`btn ${addNew ? 'btn-danger' : 'btn-outline-primary'} btn-sm`}
                        onClick={handleAddClick}
                    >
                        <i className={`bi ${addNew ? 'bi-x' : 'bi-plus'} me-1`}></i>
                        {addNew ? 'Cancel' : 'Add New'}
                    </button>
                </div>
            </div>

            <div className="card-body">
                {addNew && (
                    <div className="mb-4">
                        <AddLinksForm
                            clinicid={clinicId}
                            getLinks={getLinks}
                            onCancel={() => setAddNew(false)}
                            existingLinks={linkArray}  // Pass the existing links here
                        />
                    </div>
                )}

                {loading ? (
                    <Loading/>
                ) : (
                    <>
                        {Array.isArray(linkArray) && linkArray.length > 0 ? (
                            <>
                                <hr/>
                                <div className="row g-3 pt-1">
                                    {linkArray.map((linkitem, index) => (
                                        <div className="col-md-6 col-lg-6" key={index}>
                                            <LinksCard linkitem={linkitem} getLinks={getLinks}/>
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className="text-center">
                                <i className="bi bi-link-45deg display-4 text-muted"></i>
                                <h5 className="mt-3 text-muted">No Reputation Links</h5>
                                <p className="text-muted">
                                    Get started by adding your first reputation link
                                </p>
                                {!addNew && (
                                    <button
                                        className="btn btn-primary mt-2 btn-sm"
                                        onClick={handleAddClick}
                                    >
                                        <i className="bi bi-plus-lg me-1"></i>
                                        Add Your First Link
                                    </button>
                                )}
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}

export default Links